export default __webpack_public_path__ + "static/media/nav-link-active.7f3d24be.svg";